import theme from "@/styles/theme";
import InputLabel from "@mui/material/InputLabel";

export default function InputLabelStyled({
  required = false,
  label,
  disabled = false,
  hint,
}) {
  return (
    <InputLabel sx={inputLabelStyles(disabled)}>
      {label}
      {required && "*"} {hint && <span>({hint})</span>}
    </InputLabel>
  );
}

const inputLabelStyles = (disabled) => ({
  color: disabled ? theme.palette.text.disabled : theme.palette.common.black,
});
